export default "__VITE_ASSET__DPAqKgnm__"